const LEGACY_CANONICAL_SERVICE_NAMES = {
  "Troubles hormonaux": "Hormonal Disorders",
};

const FRENCH_BOOKING_SERVICE_LABELS = {
  "Virtual consultation": "Consultation virtuelle",
  "General consultation": "Consultation générale",
  "Professional mole assessment": "Évaluation professionnelle des grains de beauté",
  "Allergy testing and management": "Tests et prise en charge des allergies",
  "Food Allergy Management": "Prise en charge des allergies alimentaires",
  "Asthma and Respiratory Care": "Prise en charge de l’asthme et des troubles respiratoires",
  "Atopic Dermatitis (Eczema)": "Dermatite atopique (eczéma)",
  "Primary Immune Deficiency Diseases (PIDDs)": "Déficits immunitaires primitifs",
  "Hormonal Disorders": "Troubles hormonaux",
  Consultation: "Consultation",
};

export function canonicalizeBookingServiceName(value = "") {
  const raw = String(value || "").trim();
  return LEGACY_CANONICAL_SERVICE_NAMES[raw] || raw;
}

export function localizeBookingServiceName(value = "", languageCode = "") {
  const canonical = canonicalizeBookingServiceName(value);
  const locale = String(languageCode || "").trim().toLowerCase();
  if (!canonical || !locale.startsWith("fr")) return canonical;
  return FRENCH_BOOKING_SERVICE_LABELS[canonical] || canonical;
}
